var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAudioPause = function SvgAudioPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.33 810.67c46.93 0 85.33-38.4 85.33-85.33V298.67c0-46.93-38.4-85.33-85.33-85.33S256 251.74 256 298.67v426.67c0 46.93 38.4 85.33 85.33 85.33Zm256-512v426.67c0 46.93 38.4 85.33 85.33 85.33s85.33-38.4 85.33-85.33V298.67c0-46.93-38.4-85.33-85.33-85.33s-85.33 38.4-85.33 85.33"
  })));
};
export default SvgAudioPause;